import api from './api';

export const PromoService = {
    /**
     * @param {Object} payload
     */
    submit(payload) {
        return api().post(`/promo-code`, payload);
    }
}
